import React, { useContext, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "sprint-common-web";

import { adminIntegratorsRoute, adminRoutes } from "../../AdminRoutes";
import { IntegratorContext } from "../context/IntegratorContext";
import { IntegratorItem } from "../listing/IntegratorItem";

export const IntegratorDetailsDashboardBreadcrumb: React.FunctionComponent = () => {
    const [items, setItems] = useState<BreadcrumbItem[]>([]);

    const history = useHistory();
    const { integratorItems } = useContext(IntegratorContext);
    const { integratorId } = useParams<{ integratorId: string }>();

    useEffect(() => {
        if (integratorItems.length) {
            setItems(createBreadcrumbItems());
        }
    }, [integratorId, integratorItems]);

    const createBreadcrumbItems = () => {
        return [
            ...adminRoutes.baseRouteNames.map((name: string) => {
                return { key: name, text: name };
            }),
            {
                key: "integrators",
                text: "Integrators",
                onClick: goToIntegratorsListing
            },
            {
                key: "integratorName",
                text: getIntegratorName(integratorItems, integratorId)
            }
        ];
    };

    const goToIntegratorsListing = () => {
        history.push(adminIntegratorsRoute.path);
    };

    return <Breadcrumb items={items} />;
};

const getIntegratorName = (integrators: IntegratorItem[], id: string) => {
    const selectedIntegrator = integrators.find((integrator: IntegratorItem) => integrator.id === id);

    if (!selectedIntegrator) {
        throw new Error(`Could not find integrator ${id}`);
    }

    return selectedIntegrator.name;
};
